module.exports = __webpack_public_path__ + "img/Forget password_progress bar1.f0490090.png";